// src/db.js
import { initializeApp } from "firebase/app";
import { getAuth }       from "firebase/auth";
import { getFirestore }  from "firebase/firestore";
import { getDatabase }   from "firebase/database";

const firebaseConfig = {
  apiKey:            process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain:        process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL:       process.env.VUE_APP_FIREBASE_DB_URL,       // ← needed by RTDB
  projectId:         process.env.VUE_APP_FIREBASE_PROJECT_ID,   // ← needed by Firestore
  storageBucket:     process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_SENDER_ID,
  appId:             process.env.VUE_APP_FIREBASE_APP_ID
};

// Initialize the SDKs
const app       = initializeApp(firebaseConfig);
const auth      = getAuth(app);
const firestore = getFirestore(app);
const rtdb      = getDatabase(app);

export { auth, firestore as db, rtdb };
